// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../work/modules/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "sl-radio[data-v-e18e8f66]::part(base){--toggle-size:22px;font-size:var(--sl-font-size-x-large)}sl-radio[data-v-e18e8f66]::part(control--checked){background-color:var(--color-primary-700);border-color:var(--color-primary-700)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
